import React from 'react';
import { useContext } from 'hooks/context';
import MenuItem from '@mui/material/MenuItem';
import i18next from 'v2/helpers/i18n';
import { connect } from 'react-redux';

const DefaultButton = ({ handleClick, label = i18next.t('send-enquiry') }) => (
  <MenuItem onClick={handleClick}>{label}</MenuItem>
);

const EnquiryProModal = ({
  pid,
  tid,
  tenderAddendum,
  title = i18next.t('send-enquiry'),
  subcontractors,
  dispatch,
}) => {
  const context = useContext('clink');
  const { actions } = context;

  const handleOpen = () => {
    dispatch(
      actions.setOpenContactsModal({
        pid,
        tid,
        tenderAddendum,
        subcontractors,
      }),
    );
  };

  return <DefaultButton handleClick={handleOpen} label={title} />;
};

export default connect()(EnquiryProModal);
